export class Witness {
    get id() {
        return this.witnessState.id;
    }
    get diligenceNumber() {
        return this.witnessState.diligenceNumber;
    }
    get witnessThird() {
        return this.witnessState.witnessThird;
    }
    get manifestation() {
        return this.witnessState.manifestation;
    }
    get date() {
        return this.witnessState.date;
    }
    get presents() {
        return this.witnessState.presents;
    }
    get userId() {
        return this.witnessState.userId;
    }
    get third_name() {
        return this.witnessState.third_name;
    }
    set diligenceNumber(diligenceNumber) {
        this.witnessState.diligenceNumber = diligenceNumber;
    }
    set witnessThird(witnessThird) {
        this.witnessState.witnessThird = witnessThird;
    }
    set manifestation(manifestation) {
        this.witnessState.manifestation = manifestation;
    }
    set date(date) {
        this.witnessState.date = date;
    }
    set presents(presents) {
        this.witnessState.presents = presents;
    }
    set userId(userId) {
        this.witnessState.userId = userId;
    }
    constructor(witnessState) {
        this.witnessState = witnessState;
    }
    getState() {
        return this.witnessState;
    }
}
